<template>
  <div class="kr-layout-content">
    <div class="adaption-top">
      <!-- <i class="iconfont icon-fanhui1" @click="back"></i> -->
      <div class="logo">
        <img src="../../assets/img/logo.png" alt />
      </div>
      <div class="open" @click.stop="codeShow">下载APP</div>
      <div v-if="topShow" class="open-code" style="left:calc(100% - 75px);margin-left:0px">
        <img src="../../assets/img/code.png" alt />
      </div>
    </div>

    <!--公司名称-->
    <div class="content-left">
      <div class="post-details">
        <div class="post-name">
          <!-- <span class="card">艺术</span> -->
          {{content.title}}
        </div>
        <ul class="sea-list">
          <li v-for="(items,index) in tags" :key="index" v-if="items != ''">{{items}}</li>
        </ul>
        <p style="margin:18px 0px 15px;">办公地址：{{content.cityName}}{{content.address}}</p>
        <!-- <p class="deadline">有效期：{{content.createTime}}</p> -->
        <!--文章-->
        <div class="article">
          <!-- <p class="title">{{content.subTitle}}</p> -->
          <p v-html="content.des"></p>
        </div>
        <!--收藏-->
        <ul class="care">
          <li class="look-more collect" @click="getCollect">
            <i :class="['iconfont',isCangEd == 1 ? 'active':'']"></i>
            <span v-text="isCollect">收藏职位</span>
          </li>
          <li class="look-more" @click="callUs">
            <i class="iconfont icon-dianhua"></i>立即联系
          </li>
          <div v-if="telShow" class="telephone">{{content.phone}}</div>
        </ul>
      </div>
    </div>

    <!--右边-->
    <div class="content-right">
      <div class="user-data">
        <div class="user">
          <div class="user-img">
            <img :src="userInfo.pic" alt />
          </div>
          <div class="cont">
            <p class="nick oneline">{{userInfo.nickName}}</p>
            <!-- <span class="rank">新锐作者</span> -->
            <span class="rank care" @click="Care" v-text="isCare"></span>
          </div>
        </div>
        <p class="msg">{{userInfo.des}}</p>
        <p class="msg">发表{{content.zhaopinCount}}篇文章</p>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import wx from "weixin-js-sdk";
export default {
  //   name: "App",
  data() {
    return {
      id: this.$route.query.id,
      content: {},
      tags: [],
      telShow: false,
      userInfo: {},
      isCare: "关注",
      isCollect: "收藏职位",
      isCangEd: 0,
      topShow: false,
      shareTitle: "",
      describe: "",
      firstImg: "",
      userDes:''
    };
  },
  methods: {
    back() {
      this.$router.go(-1); //返回上一层
    },
    codeShow() {
		var u = navigator.userAgent;
		var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
		var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
		if(isiOS) {
			window.location.href = 'https://apps.apple.com/cn/app/%E5%BB%BA%E7%AD%91%E6%A1%A3%E6%A1%88/id1477141350';
		}else{
			window.location.href = 'https://appgallery.huawei.com/#/app/C101058233?locale=zh_CN&source=appshare&subsource=C101058233&shareTo=weixin&shareFrom=appmarket';
		}
      // this.topShow = !this.topShow;
    },
    checkWx() {
      var that = this;
      this.$http
        .post("/api/wx/xiaochengxu/JSSDKConfig", {
          url: location.href.split("#")[0]
        })
        .then(res => {
          console.log(res, "小程序等");
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.appId, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"] // 必填，需要使用的JS接口列表
          });
          wx.ready(function() {
            // console.log(window.location.href)
            //需在用户可能点击分享按钮前就先调用
            wx.updateAppMessageShareData({
              title: that.shareTitle, // 分享标题
              desc: that.describe, // 分享描述
              link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: that.firstImg, // 分享图标
              success: function() {
                // 设置成功
              }
            });
            wx.updateTimelineShareData({
              title: that.shareTitle, // 分享标题
              link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: that.firstImg, // 分享图标
              success: function() {
                // 设置成功
              }
            });
          });
          wx.error(function(res) {
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    getData() {
      this.$http
        .get("/api/zhaoPin/zhaoPinDetails", {
          params: {
            id: this.id
          }
        })
        .then(res => {
          console.log(res, "招聘详情");
          if (res.data.code == 0) {
            this.content = res.data.rows[0];
            this.userDes = res.data.rows[0].des;
            this.tags = res.data.rows[0].tags.replace(new RegExp("，", "g"), ",").split(",");
            this.isCangEd = res.data.rows[0].isCangEd;
            this.getAuthor(res.data.rows[0].userId);
            this.shareTitle = res.data.rows[0].title;
             this.describe = $(this.userDes).text().substr(0, 20) + "......";
            if ($(this.userDes).find("img")) {
              this.firstImg = $(this.userDes).find("img").attr("src");
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //收藏
    getCollect() {
      this.$http
        .get("/api/core/004-userShouCangPc", {
          params: {
            token: this.$store.state.userInfo.token,
            thirdId: this.id,
            type: 3,
            thirdName: this.userInfo.nickName
          }
        })
        .then(res => {
          // console.log(res, "收藏");
          if (res.data.code == 0) {
            if (res.data.msg == "取消收藏成功") {
              this.isCollect = "收藏职位";
              this.isCangEd = 0;
            } else {
              this.isCollect = "已收藏";
              this.isCangEd = 1;
            }
          } else {
            this.$message(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    Care() {
      console.log(this.content.userId + "--" + this.content.userName);
      //关注
      this.$http
        .get("/api/core/009-userFocusPc", {
          params: {
            token: this.$store.state.userInfo.token,
            type: 3,
            friendId: this.content.userId,
            friendName: this.userInfo.nickName
          }
        })
        .then(res => {
          // console.log(res, "关注");
          if (res.data.code == 0) {
            if (res.data.msg == "取关成功") {
              this.isCare = "关注";
            } else {
              this.isCare = "已关注";
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getAuthor(userId) {
      // 获取作者信息
      this.$http
        .get("/api/user/013-getUserInfoById", {
          params: {
            id: userId
          }
        })
        .then(res => {
          // console.log(res, "招聘详情作者");
          if (res.data.code == 0) {
            this.userInfo = res.data.rows[0];
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 联系我们
    callUs() {
      if (this.$store.state.userInfo.token) {
        this.telShow = !this.telShow;
      } else {
        this.$message("请登录");
      }
    }
  },
  mounted() {
    this.getData();
    var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      this.checkWx();
    }
  }
};
</script>
<style scoped>
/* 头部隐藏 */
.adaption-top {
  display: block;
  width: calc(100% - 24px);
  height: 50px;
  line-height: 50px;
  position: fixed;
  top: 0px;
  z-index: 989;
  background: #fff;
}
.adaption-top::after {
  content: "";
  width: 110%;
  height: 1px;
  background: #bbb;
  position: absolute;
  left: -12px;
  right: 0px;
  bottom: 0px;
}

.adaption-top i {
  float: left;
  margin-top: 14px;
  font-size: 22px;
  position: absolute;
  left: -5px;
}

/* 打开详情*/
.adaption-top .logo {
  width: auto;
  height: 26px;
  float: left;
}
.adaption-top .logo img {
  height: 100%;
  width: auto;
}
.adaption-top .open {
  width: 80px;
  height: 26px;
  text-align: center;
  line-height: 26px;
  color: #0a8228;
  margin-top: 12px;
  float: right;
  border: 1px solid #0a8228;
}
.adaption-top .open-code {
  width: 70px;
  height: 70px;
  padding: 8px 3px 3px;
  position: absolute;
  right: 6px;
  top: 40px;
  background: url("../../assets/img/code-bg.png") no-repeat;
  background-size: 100% 100%;
}
.new-article .art-list li .content .author .name {
  padding-left: 0px;
}
.new-article {
  margin-top: 30px;
}
.post-details .article {
  margin-top: 0px;
  padding-bottom: 45px;
}
.post-details .article .title {
  margin-bottom: 30px;
}
.sea-list {
  margin-top: 20px;
}
.sea-list::after {
  content: "";
  display: block;
  clear: both;
  width: 100px;
  height: 1px;
  background: #ededed;
}
.sea-list > li {
  font-size: 16px;
  height: 30px;
  line-height: 30px;
  margin: 0px 20px 20px 0px;
}
.post-details .care {
  position: relative;
}
.user-data {
  width: 100%;
}
.look-more {
  width: calc(50% - 12px);
  float: left;
  clear: none;
}
.look-more:hover {
  cursor: pointer;
}
.look-more:last-child {
  border: none;
}
.look-more.collect:hover i::before {
  color: #fff;
}
.look-more:first-child {
  margin-right: 12px;
}
.look-more i {
  font-size: 14px;
  margin-right: 9px;
}
.look-more.collect i::before {
  content: "\e603";
  font-size: 16px;
  color: #2e8043;
}
.look-more.collect i.active::before {
  content: "\e600";
}
.look-more:nth-child(2) {
  color: #fff;
  background: #2e8043;
}
.card {
  margin-top: 9px;
}
.telephone {
  width: calc(50% - 12px);
  height: 80px;
  text-align: center;
  line-height: 80px;
  background: #ededed;
  position: absolute;
  right: 10px;
  top: 40px;
  font-size: 20px;
}

@media (min-width: 800px) and (max-width: 1099px) {
  .post-details .post-name {
    font-size: 23px;
  }
  .content-left {
    padding-bottom: 0px;
  }
  .content-right {
    width: 100%;
    padding: 30px 0px 60px 20px;
    float: none;
  }
}
@media (min-width: 720px) and (max-width: 799px) {
  .post-details .post-name {
    font-size: 22px;
  }
  .content-left {
    padding-bottom: 0px;
  }
  .content-right {
    width: 100%;
    padding: 30px 0px 60px 20px;
    float: none;
  }
}
@media (min-width: 640px) and (max-width: 719px) {
  .content-left {
    padding-bottom: 0px;
  }
  .content-right {
    padding: 30px 0px 60px 20px;
    float: none;
  }
  .content-right {
    width: 100%;
    padding: 30px 0px 60px 20px;
    float: none;
  }
}
@media (max-width: 639px) and (min-width: 415px) {
  .content-left {
    padding-bottom: 0px;
  }
  .content-right {
    width: 100%;
    padding: 30px 0px 60px 20px;
    float: none;
  }
}
@media (min-width: 320px) and (max-width: 414px) {
  .content-left {
    padding: 10px 0px 0px 0px;
  }
  .content-right {
    width: 100%;
    padding: 30px 0px 60px 20px;
    float: none;
  }
  .post-details .post-name {
    font-size: 16px;
  }
  .sea-list {
    margin-top: 10px;
  }
  .sea-list > li {
    height: 25px;
    line-height: 25px;
    font-size: 14px;
    margin: 0px 15px 15px 0px;
    padding: 0px 12px;
  }
}
</style>